<script lang="ts">
import { Container } from 'inversify'
import { computed, defineComponent } from 'vue'

import { StatusType } from '@collector/sportsapi-client-legacy'
import EventHeader from '@mobile/views/Relation/Shared/EventHeader/EventHeader.vue'
import Popup from '@mobile/views/Relation/Shared/Popup/Popup.vue'
import { bindSeasonParticipants } from '@mobile/views/Relation/Shared/RelationDependencies/bindSeasonParticipants'
import { bindSkins } from '@mobile/views/Relation/Shared/RelationDependencies/bindSkins'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import VerifyResults from '@mobile/views/Relation/Shared/VerifyResults/VerifyResults.vue'
import { bindActiveParticipant } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindActiveParticipant'
import { bindAssignableIncidentConfiguration } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindAssignableIncidentConfiguration'
import { bindEventClockConfiguration } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindEventClockConfiguration'
import { bindEventHeaderConfiguration } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindEventHeaderConfiguration'
import { bindEventStatusesConfiguration } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindEventStatusesConfiguration'
import { bindEventStatusesList } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindEventStatusesList'
import { bindIncidentHandlersConfiguration } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindIncidentHandlersConfiguration'
import { bindIncidentsConfiguration } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindIncidentsConfiguration'
import { bindLineupsConfiguration } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindLineupsConfiguration'
import { bindRelationHooks } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/bindRelationHooks'
import { CricketRelationIoCBindings } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/CricketRelationDependencies'
import LiveView from '@mobile/views/Relation/Sports/Cricket/LiveView/LiveView.vue'

import { RelationSportOptionalIoCBindings } from '../../Shared/RelationSportCommonDependencies/relationSportOptionalDependencies'
import { bindEventSettings } from './CricketRelationDependencies/bindEventSettings'
import { bindEventStatsComponent } from './CricketRelationDependencies/bindEventStatsComponent'
import { bindEventSubParticipants } from './CricketRelationDependencies/bindEventSubParticipants'
import { bindIncidentsResultConfiguration } from './CricketRelationDependencies/bindIncidentsResultConfiguration'

export default defineComponent({
  components: {
    VerifyResults,
    LiveView,
    Popup,
    EventHeader,
  },
  setup() {
    const { probableEvent } = useEventInjections()
    const displayVerifyResults = computed(() => {
      const probableRelationStatus = probableEvent.value?.status_type

      return probableRelationStatus === StatusType.Finished
    })

    return { displayVerifyResults }
  },
})

export function bindCricketRelationDependencies(
  ioc: Container,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<any, any> {
  bindEventStatusesConfiguration(ioc)
  bindIncidentHandlersConfiguration(ioc)
  bindEventStatusesList(ioc)
  bindIncidentsConfiguration(ioc)
  bindIncidentsResultConfiguration(ioc)
  bindSeasonParticipants(ioc)
  bindLineupsConfiguration(ioc)
  bindAssignableIncidentConfiguration(ioc)
  bindActiveParticipant(ioc)
  bindEventStatsComponent(ioc)
  bindRelationHooks(ioc)
  bindEventHeaderConfiguration(ioc)
  bindEventClockConfiguration(ioc)
  bindEventSettings(ioc)
  bindEventSubParticipants(ioc)

  bindSkins(ioc)

  return { ...CricketRelationIoCBindings, ...RelationSportOptionalIoCBindings }
}
</script>

<template>
  <Popup />
  <EventHeader />
  <VerifyResults v-if="displayVerifyResults" />
  <LiveView v-else />
</template>
